module.exports = __webpack_public_path__ + "img/horizontal_7_4_8017.c41b2d1e.png";